import {call, put, takeLatest} from 'redux-saga/effects';
import userActions from '../actions/user.actions';
import UserApi from '../api/UserApi';

export function* updateTwoFactorAuthentication(action) {
    try {
        const result = yield call(UserApi.updateTwoFactorAuthentication, action.payload);
        yield put(userActions.updateTwoFactorAuthenticationSuccess(result));
    } catch (e) {
        yield put(userActions.updateTwoFactorAuthenticationFailed(e));
    }
}

export function* checkEmailVerification() {
    try {
        const result = yield call(UserApi.checkEmailVerification, {});
        yield put(userActions.checkEmailVerificationSuccess(result));
    } catch (e) {
        yield put(userActions.checkEmailVerificationFailed(e));
    }
}

function* userSaga() {
    yield takeLatest(
        userActions.TYPES.UPDATE_TWO_FACTOR_AUTHENTICATION,
        updateTwoFactorAuthentication
    );
    yield takeLatest(userActions.TYPES.CHECK_EMAIL_VERIFICATION, checkEmailVerification);
}

export default userSaga;
